import { queryOptions } from '@tanstack/react-query';
import { ProducerService } from '@/features/producers/services/ProducerService.ts';

export const producerQueryKeys = {
  all: ['producers'],
  list: () => [...producerQueryKeys.all, 'list'],
};

export const producerQueries = {
  list: () =>
    queryOptions({
      queryKey: producerQueryKeys.list(),
      queryFn: ProducerService.list,
    }),
};
